import type { DirectoryLocation } from "@/types/directory";

export const locations: DirectoryLocation[] = [
  {
    id: "loc-district-01",
    slug: "south-canara",
    name: "South Canara",
    type: "district",
    districtSlug: "south-canara",
    businessCount: 1840,
    image:
      "https://readdy.ai/api/search-image?query=Coastal%20Indian%20city%20skyline%20of%20Mangaluru%20with%20modern%20buildings%2C%20palm%20trees%20and%20warm%20golden%20sunset%20over%20the%20Arabian%20Sea%2C%20scenic%20city%20photography&width=900&height=700&seq=cbc-district-southcanara-01&orientation=landscape",
  },
  {
    id: "loc-district-02",
    slug: "udupi",
    name: "Udupi",
    type: "district",
    districtSlug: "udupi",
    businessCount: 1260,
    image:
      "https://readdy.ai/api/search-image?query=Tranquil%20temple%20town%20coastline%20in%20Udupi%20Karnataka%20with%20traditional%20temple%20architecture%2C%20coconut%20palms%20and%20calm%20sea%2C%20scenic%20travel%20photography&width=900&height=700&seq=cbc-district-udupi-01&orientation=landscape",
  },
  {
    id: "loc-district-03",
    slug: "north-canara",
    name: "North Canara",
    type: "district",
    districtSlug: "north-canara",
    businessCount: 980,
    image:
      "https://readdy.ai/api/search-image?query=Scenic%20Karwar%20coastal%20bay%20in%20Karnataka%20with%20fishing%20boats%2C%20green%20hills%20and%20calm%20blue%20water%20at%20sunset%2C%20travel%20destination%20photography&width=900&height=700&seq=cbc-district-northcanara-01&orientation=landscape",
  },
  {
    id: "loc-town-01",
    slug: "mangaluru",
    name: "Mangaluru",
    type: "town",
    districtSlug: "south-canara",
    businessCount: 1420,
    image:
      "https://readdy.ai/api/search-image?query=Bustling%20urban%20commercial%20street%20in%20Mangaluru%20Karnataka%20with%20shops%2C%20trees%20and%20warm%20daylight%2C%20city%20life%20photography&width=900&height=700&seq=cbc-town-mangaluru-01&orientation=landscape",
  },
  {
    id: "loc-town-02",
    slug: "puttur",
    name: "Puttur",
    type: "town",
    districtSlug: "south-canara",
    businessCount: 268,
    image:
      "https://readdy.ai/api/search-image?query=Green%20town%20centre%20in%20Puttur%20Karnataka%20with%20local%20shops%20and%20lush%20areca%20trees%2C%20warm%20daylight%2C%20town%20photography&width=900&height=700&seq=cbc-town-puttur-01&orientation=landscape",
  },
  {
    id: "loc-town-03",
    slug: "surathkal",
    name: "Surathkal",
    type: "town",
    districtSlug: "south-canara",
    businessCount: 214,
    image:
      "https://readdy.ai/api/search-image?query=Coastal%20town%20road%20in%20Surathkal%20Karnataka%20near%20the%20beach%20with%20shops%20and%20warm%20evening%20light%2C%20town%20photography&width=900&height=700&seq=cbc-town-surathkal-01&orientation=landscape",
  },
  {
    id: "loc-town-04",
    slug: "moodabidri",
    name: "Moodabidri",
    type: "town",
    districtSlug: "south-canara",
    businessCount: 132,
    image:
      "https://readdy.ai/api/search-image?query=Historic%20town%20street%20in%20Moodabidri%20Karnataka%20with%20traditional%20architecture%20and%20local%20shops%2C%20warm%20daylight%2C%20town%20photography&width=900&height=700&seq=cbc-town-moodabidri-01&orientation=landscape",
  },
  {
    id: "loc-town-05",
    slug: "udupi-city",
    name: "Udupi City",
    type: "town",
    districtSlug: "udupi",
    businessCount: 760,
    image:
      "https://readdy.ai/api/search-image?query=Bustling%20market%20street%20in%20Udupi%20Karnataka%20with%20shops%2C%20temple%20gopuram%20in%20the%20distance%20and%20warm%20daylight%2C%20city%20photography&width=900&height=700&seq=cbc-town-udupicity-01&orientation=landscape",
  },
  {
    id: "loc-town-06",
    slug: "manipal",
    name: "Manipal",
    type: "town",
    districtSlug: "udupi",
    businessCount: 318,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20university%20town%20street%20in%20Manipal%20Karnataka%20with%20cafes%20and%20clean%20architecture%2C%20bright%20daylight%2C%20town%20photography&width=900&height=700&seq=cbc-town-manipal-01&orientation=landscape",
  },
  {
    id: "loc-town-07",
    slug: "kundapura",
    name: "Kundapura",
    type: "town",
    districtSlug: "udupi",
    businessCount: 186,
    image:
      "https://readdy.ai/api/search-image?query=Quiet%20coastal%20town%20in%20Kundapura%20Karnataka%20with%20fishing%20harbour%2C%20palms%20and%20warm%20evening%20light%2C%20town%20photography&width=900&height=700&seq=cbc-town-kundapura-01&orientation=landscape",
  },
  {
    id: "loc-town-08",
    slug: "karkala",
    name: "Karkala",
    type: "town",
    districtSlug: "udupi",
    businessCount: 154,
    image:
      "https://readdy.ai/api/search-image?query=Traditional%20town%20in%20Karkala%20Karnataka%20with%20granite%20hill%20views%20and%20local%20markets%2C%20warm%20daylight%2C%20town%20photography&width=900&height=700&seq=cbc-town-karkala-01&orientation=landscape",
  },
  {
    id: "loc-town-09",
    slug: "karwar",
    name: "Karwar",
    type: "town",
    districtSlug: "north-canara",
    businessCount: 342,
    image:
      "https://readdy.ai/api/search-image?query=Beautiful%20coastal%20town%20of%20Karwar%20Karnataka%20with%20harbour%2C%20boats%20and%20green%20hills%2C%20warm%20sunset%20light%2C%20town%20photography&width=900&height=700&seq=cbc-town-karwar-01&orientation=landscape",
  },
  {
    id: "loc-town-10",
    slug: "sirsi",
    name: "Sirsi",
    type: "town",
    districtSlug: "north-canara",
    businessCount: 176,
    image:
      "https://readdy.ai/api/search-image?query=Pleasant%20green%20town%20of%20Sirsi%20Karnataka%20with%20tree-lined%20streets%20and%20local%20markets%2C%20warm%20daylight%2C%20town%20photography&width=900&height=700&seq=cbc-town-sirsi-01&orientation=landscape",
  },
  {
    id: "loc-town-11",
    slug: "bhatkal",
    name: "Bhatkal",
    type: "town",
    districtSlug: "north-canara",
    businessCount: 128,
    image:
      "https://readdy.ai/api/search-image?query=Coastal%20town%20of%20Bhatkal%20Karnataka%20with%20market%20streets%20and%20sea%20views%2C%20warm%20daylight%2C%20town%20photography&width=900&height=700&seq=cbc-town-bhatkal-01&orientation=landscape",
  },
  {
    id: "loc-town-12",
    slug: "ankola",
    name: "Ankola",
    type: "town",
    districtSlug: "north-canara",
    businessCount: 98,
    image:
      "https://readdy.ai/api/search-image?query=Peaceful%20coastal%20village%20town%20of%20Ankola%20Karnataka%20with%20coconut%20groves%20and%20beach%2C%20warm%20light%2C%20town%20photography&width=900&height=700&seq=cbc-town-ankola-01&orientation=landscape",
  },
];